import React from 'react';
import { HashRouter, Route, Switch, Redirect, Prompt } from 'react-router-dom';
import Main from './pages/main.page';
import LiteMain from './pages/lite-main.page';
import Start from './pages/start.page';
import CodePage from './pages/code.page';
import HomePage from './pages/home-page';
import LiteHomePage from './pages/lite-home-page';

const BasicRoute = () => {
    return (
        <HashRouter>
            <>
                <Switch>
                    <Route exact path="/" render={props => <Start {...props} />} />
                    <Route exact path="/lite" render={props => <Start {...props} />} />
                    <Route exact path="/Home" render={props => <HomePage {...props} />} />
                    <Route exact path="/Main" component={Main} />
                    <Route exact path="/Code" render={props => <CodePage {...props} />} />
                    <Route exact path="/LiteHome" render={props => <LiteHomePage {...props} />} />
                    <Route exact path="/LiteMain" component={LiteMain} />
                    <Redirect from="/*" to="/" />
                </Switch>
                <Prompt message={(location) => {
                    if (window !== window!.top) {
                        // ! 这里是为了boxed模式下使用的，因为使用iframe来实现，所以为了保持浏览器的路劲与ifram的路径一致而使用了这种办法。
                        if (!!(window!.top!.history && window!.top!.history.replaceState)) {
                            window!.top!.history.replaceState(null, '', '#' + location.pathname + location.search)
                        } else {
                            window!.top!.location.hash = location.pathname + location.search
                        }
                    }
                    return true;
                }} when={true}></Prompt>
            </>
        </HashRouter>)
}

export default BasicRoute;